import React from 'react'
import asideModalStore from 'Stores/asideModalStore'
import FormField from 'components/UI/AsideModal/Form/FormField'
import FormLabel from 'components/UI/AsideModal/Form/FormLabel'
import { observer } from 'mobx-react'
import SelectCustom from '../../../../ContentBox/Global/Select/SelectCustom'
import FormInput from '../../../../UI/AsideModal/Form/FormInput'
import FormFieldset from '../../../../UI/AsideModal/Form/FormFieldset'

const RequiredFieldsModal = observer(() => {
  const {
    modalValues: modalValue,
    changeValue: changeValues,
    check,
  } = asideModalStore

  return (
    <FormFieldset>
      <FormField>
        <FormLabel isRequired>Ответственный:</FormLabel>
        <SelectCustom
          placeholder={'Ответственный'}
          apiLinkCRM={'integration/employees'}
          apiConfParams={{ short_form: true }}
          sortKey='name'
          valueID={modalValue.manager}
          onChange={(manager) => changeValues(manager.id, 'manager')}
          isSearchable
          error={check('manager')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>Бюджет, ₸:</FormLabel>
        <FormInput isError={check('budget')}>
          <input
            placeholder='Бюджет'
            type='number'
            value={modalValue.budget || ''}
            onChange={(e) => changeValues(e.target.value, 'budget')}
          />
        </FormInput>
      </FormField>

      <FormField>
        <FormLabel isRequired>{'Город'}:</FormLabel>
        <SelectCustom
          placeholder={'Город'}
          apiLinkCRM={'integration/cities'}
          apiConfParams={{ limit: 99 }}
          sortKey='name'
          valueID={modalValue.city}
          onChange={(city) => changeValues(city.id, 'city')}
          isSearchable
          error={check('city')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>Филиал:</FormLabel>
        <SelectCustom
          placeholder='Филиал'
          apiLinkCRM={'integration/branches'}
          sortKey='name'
          valueID={modalValue.branch}
          onChange={(branch) => changeValues(branch.id, 'branch')}
          isSearchable
          error={check('branch')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>Программа:</FormLabel>
        <SelectCustom
          placeholder='Программа'
          apiLinkCRM={'integration/programs'}
          sortKey='name'
          valueID={modalValue.program}
          onChange={(program) => changeValues(program.id, 'program')}
          isSearchable
          error={check('program')}
        />
      </FormField>

      <FormField>
        <FormLabel isRequired>{'Источник'}:</FormLabel>
        <SelectCustom
          placeholder={'Источник'}
          apiLinkCRM={'settings/project_settings/deal_source_choices'}
          apiGetResult={(result) => result.value.choices}
          valueID={modalValue.source}
          optionLabelKey='name'
          optionValueKey='name'
          onChange={(level) => changeValues(level.name, 'source')}
          isSearchable
          error={check('source')}
        />
      </FormField>
    </FormFieldset>
  )
})

export default RequiredFieldsModal
